import * as React from "react";
import { Box } from "@mui/material";
import { connect } from "react-redux";
import { loginUsher } from "../../app/store/actions/authActions";
import { Navigate } from "react-router-dom";
import { MainInput, MainPassword } from "../../app/components/Styles";
import { MarketingFormPage, MarketingButton } from "../../app/components/marketing";

export const UsherLogin = ({ loginUsher, user, token, isLoading }) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    loginUsher({
      username: data.get("username"),
      password: data.get("password"),
    });
  };

  if (user) {
    return <Navigate to={`/${token.split(" ")[0]}`} replace />;
  }

  return (
    <MarketingFormPage
      maxWidth="sm"
      title="Usher sign in"
      subtitle="Scan tickets at the gate with your usher account"
      loading={isLoading}
    >
      <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
        <MainInput
          margin="normal"
          required
          fullWidth
          id="username"
          label="Username"
          name="username"
          autoComplete="username"
          autoFocus
        />
        <MainPassword
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          autoComplete="current-password"
        />
        <MarketingButton type="submit" fullWidth sx={{ mt: 3, mb: 2 }}>
          Sign in
        </MarketingButton>
      </Box>
    </MarketingFormPage>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.auth?.isLoading,
  token: state?.auth?.token,
});

const mapDispatchToProps = { loginUsher };

export default connect(mapStateToProps, mapDispatchToProps)(UsherLogin);
